// 该配置主要用于页面内按钮权限判断，key为按钮，值对应权限资源管理的资源code
export const permissionCodes: any = {
  // 患者档案
  tabDrugRecord: 'per:use:q', // 用药记录
  tabTakeDrugRecord: 'per:med:q', // 服药记录
  tabAdminRecords: 'per:med:r', // 管理记录
  tabAdminProjects: 'per:med:p', // 管理项目
  tabBasicInfo: 'per:med:b', // 基本信息
  tabPatientUploadInformation: 'per:med:u', // 患者上传资料
  patientImport: 'per:med:i', // 患者导入
  tabServer: 'per:server:q', // 服药记录
  tabConsult: 'per:consult:q', // 咨询记录
  tabAERecord: 'per:ae:q', // AE事件记录
  consultBtn: 'per:consult:c', // 即时聊天发起按钮
  hospital: 'hospital', // 即时聊天发起按钮
};

export default permissionCodes;
